/**
 * Vyvolá stažení souboru.
 * @param uri Cesta k souboru.
 * @param filename Název souboru.
 */
export const downloadFile = (uri: string, filename?: string) => {
    const link = document.createElement("a");
    link.download = filename ?? "";
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    link.remove();
};
